module.exports = __webpack_public_path__ + "static/media/img-get-tower-cz.73567710.png";